<script setup lang="ts">
import { ref, watch } from 'vue'
import { cn } from '@ds/lib/utils'
import { PinInput, PinInputSlot } from '@ds/primitives/pin-input'

const { length = 6, disabled = false, class: className } = defineProps<{
  length?: number
  disabled?: boolean
  class?: string
}>()

const modelValue = defineModel<string>({ required: true })

const pinValue = ref<number[]>(modelValue.value.split('').map(Number))

watch(pinValue, value => {
  modelValue.value = value.join('')
}, { deep: true })

const containerRef = ref<HTMLDivElement>()

defineExpose({
  focus: () => containerRef.value?.querySelector('input')?.focus(),
})
</script>

<template>
  <div
    ref="containerRef"
    class="contents"
  >
    <PinInput
      v-model="pinValue"
      :disabled
      otp
      type="number"
      :class="cn('grid gap-2', className)"
      :style="{ gridTemplateColumns: `repeat(${length}, minmax(0, 1fr))` }"
    >
      <PinInputSlot
        v-for="n in length"
        :key="n"
        :index="n - 1"
      />
    </PinInput>
  </div>
</template>
